module.exports = __webpack_public_path__ + "static/media/de.9055797c.svg";